import React from 'react';
import { Dropdown, Select, Tooltip } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import useCurrentFarm from '../hooks/useCurrentFarm';

const ALL_FARMS = 'all';

/** Sidebar farm switcher. Hidden when the user has a single farm (it is always selected). */
export default function SidebarFarmSwitcher({ collapsed = false }) {
  const { farmId, farm, farms, setFarmId } = useCurrentFarm();

  if (farms.length <= 1) return null;

  const options = [
    { value: ALL_FARMS, label: 'All farms' },
    ...farms.map((f) => ({ value: f.id, label: f.name })),
  ];
  const handleChange = (value) => setFarmId(value === ALL_FARMS ? null : value);
  const currentLabel = farm ? farm.name : 'All farms';

  if (collapsed) {
    return (
      <div className="sidebar-farm-switcher sidebar-farm-switcher--collapsed">
        <Dropdown
          trigger={['click']}
          placement="bottomLeft"
          menu={{
            items: options.map((o) => ({ key: String(o.value), label: o.label })),
            selectable: true,
            selectedKeys: [String(farmId ?? ALL_FARMS)],
            onClick: ({ key }) => handleChange(key === ALL_FARMS ? ALL_FARMS : Number(key)),
          }}
        >
          <Tooltip title={`Farm: ${currentLabel}`} placement="right">
            <button type="button" className="sidebar-farm-switcher-icon" aria-label={`Farm: ${currentLabel}`}>
              <HomeOutlined />
            </button>
          </Tooltip>
        </Dropdown>
      </div>
    );
  }

  return (
    <div className="sidebar-farm-switcher">
      <Select
        value={farmId ?? ALL_FARMS}
        onChange={handleChange}
        options={options}
        showSearch
        optionFilterProp="label"
        prefix={<HomeOutlined />}
        popupMatchSelectWidth={false}
        aria-label="Selected farm"
        className="sidebar-farm-switcher-select"
      />
    </div>
  );
}
